import { Locale } from '@ps-smart-cp/ppfw-client';

const historyProcessClassConfig = {
  laArticleInfoChange: new Map([[Locale.ja, 'リース物件情報変更']]),
  laStartRegistration: new Map([[Locale.ja, 'リース開始登録']]),
  laContractInfoChange: new Map([[Locale.ja, 'リース契約情報変更']]),
  laCancelBeforeMaturity: new Map([[Locale.ja, 'リース中途解約']]),
  reLeaseAndContractExpired: new Map([[Locale.ja, '再リース及び契約満了']]),
};

export { historyProcessClassConfig };
